<template>
    <div>
        <div class="flex w-full flex-row flex-wrap flex-xl-nowrap"  v-show="show">
            <div class="w-1/2 pr-1 lg:pl-1 xl:pl-0 xl:pr-0 lg:w-1/4 xl:w-1/5 xl:mr-4 mb-1 lg:mb-0">
                <label class="text-sm text-grey-darkest">Filter by User</label>
                <multiselect class="cursor-pointer" :options="users" v-model="selectedUser" :show-labels="false"
                             track-by="id" label="name"></multiselect>
            </div>
            <div class="mt-3 lg:mt-8 w-full lg:w-1/4 xl:w-1/5">
                <div class="row w-full px-4 justify-between">
                    <div class="flex">
                        <button
                            class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 rounded-full text-followup-nav"
                            @click="applyFilter" type="button">
                            Apply
                        </button>
                    </div>
                    <div class="flex items-center">
                        <div class="text-2xl cursor-pointer">
                            <span class="material-icons hover:text-followup-nav" @click="show = !show">close</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div  v-show="!show" class="flex w-full flex-row justify-end text-2xl mb-3 cursor-pointer">
            <i class="material-icons hover:text-followup-nav" @click="show = !show">more_vert</i>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        components: {Multiselect},
        props: ['user', 'redirectUrl'],

        created() {
            this.fetchData();
        },

        data() {
            return {
                users: [],
                selectedUser: this.user ? this.user : null,
                show: true,
            }
        },

        methods: {
            fetchData() {
                let self = this;
                axios.get(route('date-ranges')).then((data) => {
                    self.users = data.data.users;
                    self.users.unshift({id: 0, name: 'Company'});
                });
            },

            applyFilter() {
                let uri = "";

                if (this.selectedUser) {
                    uri += "?user=" + this.selectedUser.id;
                }

                const urlParams = new URLSearchParams(window.location.search);

                if (urlParams.has('stage')){
                    uri += "&stage=" + urlParams.get('stage');
                }

                if (urlParams.has('type')){
                    uri += "&type=" + urlParams.get('type');
                }

                window.location = this.redirectUrl + uri;
            },
        },

    }
</script>
